import { useEffect } from 'react'
import useCampaign from './useCampaign'

export default ({ utmSource, utmMedium, utmCampaign, utmTerm, utmContent }) => {
  const [, setState] = useCampaign()

  useEffect(() => {
    if (utmSource || utmMedium || utmCampaign || utmTerm || utmContent) {
      setState({ utmSource, utmMedium, utmCampaign, utmTerm, utmContent })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
}
